import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * YouTube's mobile top bar — brand on the left, cast / notifications / search
 * on the right. Separate from {@link YoutubeNavbarComponent}, which is the
 * desktop bar and carries a hamburger and a search field the mobile app has no
 * room for.
 */
@Component({
    selector: 'app-youtube-mobile-navbar',
    imports: [CommonModule],
    templateUrl: './youtube-mobile-navbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './youtube-mobile-navbar.component.scss'
})
export class YoutubeMobileNavbarComponent {}
